<template>
<div class="userArchivesPage">
    <div class="userArchivesCon">
        <div class="noPrintModel"></div>
        <div class="tableHeaderTit">
            <h2>民警警衔晋升训练免试、免训（缓训）申请表</h2>
        </div>
        <table>
            <tr>
                <td class="tableLabel">姓名</td>
                <td>{{applicationInfo.username}}</td>
                <td class="tableLabel">性别</td>
                <td>{{applicationInfo.sex}}</td>
                <td style="width: 100px;" class="tableLabel">出生日期</td>
                <td class="dateText" style="width: 110px;">{{applicationInfo.birthday}}</td>
            </tr>
            <tr style="height:50px;">
                <td class="tableLabel">单位部门</td>
                <td colspan="3">{{applicationInfo.unit}}</td>
                <td class="tableLabel">拟晋升警衔</td>
                <td>二级警督</td>
            </tr>
            <tr>
                <td colspan="6">
                    <div style="min-height: 115px;" class="oneMesConModel oneApplyForBox">
                        <div class="twoTit">申请原因：</div>
                        <div class="msgCon">{{applicationInfo.cause}}</div>
                        <div style="bottom:2px;" class="personText">
                            <div class="lineText">
                                <span>申请人签名：</span>
                                <span>{{applicationInfo.username}}</span>
                            </div>
                            <div class="dateText">{{applicationInfo.createtime}}</div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="oneMesConModel" colspan="6">
                    <div style="min-height: 64px;">
                        <div class="twoTit">证明材料名称（材料需要附后）：</div>
                        <div class="msgCon">{{applicationInfo.files}}</div>
                    </div>
                </td>
            </tr>
            <tr v-if="levels>2" :style="`height: ${ideaHeight}px;`">
                <td class="tableLabel" style="line-height: 30px;width: 160px;">
                    <div>县（市）公安局</div>
                    <div>政工部门审核意见</div>
                </td>
                <td class="twoMesConModel" colspan="5">
                    <div class="msgCon">{{this.ideaList[2].idea}}</div>

                    <div class="personText">
                        <div class="dateText">{{this.ideaList[2].createtime}}</div>
                    </div>
                    <img class="sealImgBox" v-if="this.ideaList[2].sealsrc" :src="this.ideaList[2].sealsrc" alt="">
                </td>
            </tr>
            <tr v-if="levels>1" :style="`height: ${ideaHeight}px;`">
                <td class="tableLabel" style="line-height: 30px;">
                    <div>州（市、地）公安局</div>
                    <div>政工部门审核意见</div>
                </td>
                <td class="threeMesConModel" colspan="5">
                    <div class="msgCon">{{this.ideaList[1].idea}}</div>
                    
                    <div class="personText">
                        <div class="dateText">{{this.ideaList[1].createtime}}</div>
                    </div>
                    <img class="sealImgBox" v-if="this.ideaList[1].sealsrc" :src="this.ideaList[1].sealsrc" alt="">
                </td>
            </tr>
            <tr v-if="levels>0" :style="`height: ${ideaHeight}px;`">
                <td class="tableLabel" style="line-height: 30px;">
                    <div>公安厅政治部</div>
                    <div>审核意见</div>
                </td>
                <td class="oneMesConModel" colspan="5">
                    <div class="msgCon">{{this.ideaList[0].idea}}</div>
                    
                    <div class="personText">
                        <div class="dateText">{{this.ideaList[0].createtime}}</div>
                    </div>
                    <img class="sealImgBox" v-if="this.ideaList[0].sealsrc" :src="this.ideaList[0].sealsrc" alt="">
                </td>
            </tr>
        </table>
        <div class="noPrintModel"></div>
    </div>
</div>
</template>

<script>
import {
    getExemptionTrainInfoApi
} from '@/api/train/index.js';
export default {
    name: 'userArchives',
    data(){
        return {
            sealImg: '',
            applicationInfo: {},
            ideaHeight: 230,
            levels: 0,
            ideaList:[],
        }
    },
    created(){
        this.getInfo();
    },
    methods:{
        getInfo(){
            getExemptionTrainInfoApi({id: this.$route.query.id}).then(res=>{
                if(res.code == 200){
                    this.applicationInfo = res.result;
                    let files = this.applicationInfo.files ? JSON.parse(this.applicationInfo.files) : [];
                    this.applicationInfo.files = '';
                    if(files && files.length > 0){
                        files = files.map(item=>item.fileName);
                        this.applicationInfo.files = files.join('、');
                    }

                    this.ideaList = [];
                    this.levels = this.applicationInfo.levels;
                    this.ideaHeight = 640 / this.levels;
                    for(let i=0;i<=2;i++){
                        let obj = {};
                        if(this.applicationInfo.flow[i]){
                            obj = Object.assign({},this.applicationInfo.flow[i]);
                            obj.sealsrc = (obj.state != 1 || this.applicationInfo.status == -1) ? '' : obj.sealsrc;
                            if(obj.createtime && obj.createtime.includes(':')){
                                obj.createtime = obj.createtime.split(' ');
                                obj.createtime = obj.createtime[0];
                            }
                        }else{
                            obj.createtime = '';
                            obj.idea = '';
                            obj.sealsrc = '';
                            obj.state = 0;
                        }
                        this.ideaList.push(obj);
                    }

                    if(Number(this.levels) === 3){
                        this.ideaList.reverse();
                    }else if(Number(this.levels) === 2){
                        let mol = this.ideaList[1];
                        this.ideaList[1] = this.ideaList[0];
                        this.ideaList[0] = mol;
                    }
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.userArchivesPage{
    font-family: '宋体';
    color:#000;
    font-size: 14px;
    .userArchivesCon{
        width: 190.5mm;
        height: 247mm;
        margin: auto;

        .tableHeaderTit{
            text-align: center;
            margin: 0px 0px 10px 0px;
            h2{
                font-size: 20px;
            }
        }

        table {
            width: 100%;
            box-sizing: border-box;
            background-color: #fff;
            border-collapse: collapse;

            .userImg{
                height: 200px;
                width: 150px;
            }

            th, td {
                border: 1px solid #000;
                padding: 8px;
                text-align: center;
                letter-spacing: 1px;
                box-sizing: border-box;
            }

            .nested-table{
                padding: 0px;
                tr{
                    display: flex;
                    padding: 0px;
                }
                th, td {
                    border: none;
                    display: flex;
                    align-items: center;
                }
            }

            .oneMesConModel,.twoMesConModel,.threeMesConModel{
                vertical-align: top;
                position: relative;
                text-align: left;

                .personText{
                    line-height: 26px;
                    position: absolute;
                    bottom: 10px;
                    right: 70px;
                    text-align: right;

                    .lineText{
                        position: relative;
                        right: -50px;

                        span:nth-child(2){
                            display: inline-block;
                            min-width: 120px;
                            text-align: left;
                        }
                    }
                }

                .twoTit{
                    line-height: 26px;
                }
                .msgCon{
                    line-height: 26px;
                    text-indent: 1.5em;
                }

                .sealImgBox{
                    height: 150px;
                    width: 150px;
                    position: absolute;
                    right: 35px;
                    bottom: 40px;
                }
            }
            .oneApplyForBox{
                padding-bottom: 50px;
            }
            .twoMesConModel{
                
            }
            .threeMesConModel{
                
            }
        }
    }

    .tableLabel{
        text-align: center;
        letter-spacing: 2px;
    }

    .dateText{
        // font-weight: 700;
        // font-family: '思源黑体';
    }
}

.noPrintModel{
    height: 20px;
}
@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    .noPrintModel{
        display: none;
    }
}
</style>